<template>
  <v-container grid-list-xl fluid>
    <v-layout row wrap>
      <v-progress-linear
        indeterminate
        :active="isRequestingNow.length > 0"
        color="blue"
        class="mb-0"
      ></v-progress-linear>
      <v-overlay :value="pageLoading">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
      <v-flex v-if="!pageLoading && item" style="position: relative">
        <v-container class="grey lighten-5">
          <v-row no-gutters class="pagination-table-header">
            <v-col
              cols="12"
              sm="6"
              class="py-md-0"
            >
              <v-card
                class="pa-1"
                v-if="item.order"
                style="position: relative"
              >
                <div>
                  <b>
                    <template
                      v-if="item.damagable_type === 'base'"
                    >{{ $t('damages.order_base') }}
                      <span v-if="item.order.is_subscription">
      ({{ $t('damages.subscription') }})
    </span>
                    </template>
                    <template v-else>{{ $t('damages.order_comples') }}</template>
                  </b>
                  <span>
                    [{{lang($store, `sap/listings.global.filter.order_base_types.${item.order[(item.damagable_type === 'base')?'order_base_type':'order_complex_type']}`)}}]
                  </span>, {{ $t('damages.source') }}:
                  <span>
                     {{lang($store, `sap/listings.global.filter.sources.${item.order.source}`)}}
                  </span>
                </div>
                <div>
                  <datetime-alert
                    v-if="item.order.datetime"
                    :datetime="moment(item.order.datetime)"
                  />
                </div>
                <div>
                  {{ $t('damages.note') }} 1: <span>{{item.order.minicomment}}</span>
                </div>
                <div>
                  {{ $t('damages.note') }} 2: <span>{{item.order.minicomment2}}</span>
                </div>
                <div>
                  {{ $t('damages.note') }} 3: <span>{{item.order.mininote}}</span>
                </div>
              </v-card>
            </v-col>
            <v-col
              cols="12"
              sm="6"
              class="py-md-0"
            >

              <v-card
                class="pa-1"
                v-if="item.order"
                style="position: relative"
              >
                <div style="position: absolute; bottom: calc(100% + 0px); right: 0;">
                  <router-link
                    v-if="item.damagable_type === 'base'"
                    :to="{ name: 'orders.base.show', params: { orderUuid: item.order.uuid }}">
                    <v-icon small>mdi-briefcase-edit-outline</v-icon>
                  </router-link>
                  <router-link
                    v-else
                    :to="{ name: 'orders.complex.show', params: { orderUuid: item.order.uuid }}">
                    <v-icon small>mdi-briefcase-edit-outline</v-icon>
                  </router-link>
                </div>
                <div>
                  {{item.order.contact.address_formatted}}
                </div>
                <div>
                  {{item.order.contact.address_formatted_meta}}
                </div>
                <v-divider/>
                <contact-line :contact="item.order.contact"/>
                <v-divider/>
                <cleaner-line
                  v-if="item.order.foreman"
                  :cleaner="item.order.foreman"
                  :not-found-text="lang($store, 'sap/listings.orders.foreman_not_set')"
                />
                <cleaners-line
                  v-else
                  :cleaners="item.order.cleaners"/>
              </v-card>
            </v-col>
            <v-col
              cols="12"
              sm="6"
              class="py-md-0"
            >
              <v-select
                v-model="item.status"
                :items="damageStatusesStatusItems"
                prepend-icon="mdi-cart-arrow-right"
                single-line
                :hint="lang($store, 'sap/listings.global.filter.hints.order_status')"
                persistent-hint
                :error-messages="(errors && errors.status)?errors.status:null"
                @change="updateRequest('status', $event); removeError('status')"
                :loading="isRequestingNow.includes('status')"
              ></v-select>
            </v-col>
            <v-col
              cols="12"
              md="6"
            >
              <v-text-field
                v-model="item.note"
                :counter="200"
                :rules="[rules.max(200)]"
                prepend-icon="mdi-tooltip-text-outline"
                :label="lang($store, 'sap/listings.global.filter.hints.note')"
                autocomplete="off"
                :error-messages="(errors && errors.note)?errors.note:null"
                @input="removeError('note')"
                @change="updateRequest('note', $event)"
                :loading="isRequestingNow.includes('note')"
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              md="6"
            >
              <v-textarea
                v-model="item.description"
                :counter="3000"
                :rules="[rules.max(3000)]"
                prepend-icon="mdi-account-badge-horizontal-outline"
                :label="lang($store, 'sap/listings.global.filter.hints.description')"
                autocomplete="off"
                :error-messages="(errors && errors.description)?errors.description:null"
                @input="removeError('description')"
                @change="updateRequest('description', $event)"
                :loading="isRequestingNow.includes('description')"
                :auto-grow="true"
                :rows="10"
              ></v-textarea>
            </v-col>
            <v-col
              cols="12"
              md="6"
            >
              <v-textarea
                v-model="item.result"
                :counter="3000"
                :rules="[rules.max(3000)]"
                prepend-icon="mdi-account-badge-horizontal-outline"
                :label="lang($store, 'sap/listings.global.filter.hints.result')"
                autocomplete="off"
                :error-messages="(errors && errors.result)?errors.result:null"
                @input="removeError('result')"
                @change="updateRequest('result', $event)"
                :loading="isRequestingNow.includes('result')"
                :auto-grow="true"
                :rows="10"
              ></v-textarea>
            </v-col>
            <v-col
              cols="12"
              md="6"
            >
              <v-text-field
                v-model="item.minicomment"
                :counter="200"
                :rules="[rules.max(200)]"
                prepend-icon="mdi-tooltip-text-outline"
                :label="lang($store, 'sap/listings.global.filter.hints.minicomment')"
                autocomplete="off"
                :error-messages="(errors && errors.minicomment)?errors.minicomment:null"
                @input="removeError('minicomment')"
                class="pt-2"
                @change="updateRequest('minicomment', $event)"
                :loading="isRequestingNow.includes('minicomment')"
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              md="6"
            >
              <v-text-field
                v-model="item.minicomment2"
                @change="updateRequest('minicomment2', $event)"
                :counter="200"
                :rules="[rules.max(200)]"
                prepend-icon="mdi-tooltip-text-outline"
                :label="lang($store, 'sap/listings.global.filter.hints.minicomment2')"
                autocomplete="off"
                :error-messages="(errors && errors.minicomment2)?errors.minicomment2:null"
                @input="removeError('minicomment2')"
                class="pt-0"
                :loading="isRequestingNow.includes('minicomment2')"
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              sm="12"
              class="py-md-0"
            >
              <vue-dropzone
                ref="dropzone"
                id="attachmentsUploader"
                :options="dropOptions"
                @vdropzone-complete="afterComplete"
                @vdropzone-success="onFileUploaded"
                @vdropzone-error="onFileError"
              ></vue-dropzone>
            </v-col>
            <v-col
              cols="12"
              sm="12"
              class="py-md-0"
            >
              <v-row
                v-if="item.attachments.length > 0"
              >
                <v-col
                  cols="12"
                  md="3"
                  sm="4"
                  class="py-md-0"
                  v-for="attachment in item.attachments"
                  :key="attachment.id"
                >
                  <div class="preview-attachment">
                    <a :href="attachment.link" target="_blank" class="preview-attachment__content">
                      <img v-if="isImage(attachment.link)" :src="attachment.link"
                           :alt="attachment.link">
                      <div class="text" v-else>.{{attachment.name.split('.').pop()}}</div>
                    </a>
                  </div>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-btn
            small fab dark falt fixed
            right="right"
            class="setting-fab"
            color="red"
            style="top: 54%"
            @click="isShowHistory = true"
          >
            <v-icon>mdi-history</v-icon>
          </v-btn>
          <v-navigation-drawer
            class="setting-drawer"
            style="z-index: 99;"
            right v-model="isShowHistory" fixed>
            <keep-alive>
              <activity-list
                :args="[this.item.uuid]"
                method="damageActivity"
              />
            </keep-alive>
            <div
              class="pa-1"
              @click="isShowHistory = false"
              style="opacity: 0.8; cursor: pointer; background-color: gray;text-align: right; position: absolute; top: 10px; right: 25px; border-radius: 50%; overflow: hidden">
              <v-icon>mdi-close</v-icon>
            </div>
          </v-navigation-drawer>
        </v-container>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import moment from 'moment';
import VueDropzone from 'vue2-dropzone';
/* utils */
import { prepareValidationMessages } from '@/utils';
/* proxies */
import DamageProxy from '@/proxies/Damage/DamageProxy';
/* mixins */
import updatePageContentMixin from '@/mixins/updatePageContentMixin';
import validationMixin from '@/mixins/validationMixin';
import damagesStatusFilter from '@/mixins/filters/damagesStatusFilter';
import modelUpdateSimpleProp from '@/mixins/orders/orderUpdateSimpleProp';
/* components */
import ActivityList from '@/components/activity/ActivityList.vue';
import ContactLine from '@/components/minialerts/ContactLine.vue';
import CleanersLine from '@/components/minialerts/CleanersLine.vue';
import CleanerLine from '@/components/minialerts/CleanerLine.vue';
import DatetimeAlert from '@/components/minialerts/DatetimeAlert.vue';
import i18n from '@/i18n';

export default {
  name: 'ShowDamage',
  mixins: [
    updatePageContentMixin,
    validationMixin,
    damagesStatusFilter,
    modelUpdateSimpleProp,
  ],
  components: {
    ActivityList,
    ContactLine,
    CleanersLine,
    CleanerLine,
    DatetimeAlert,
    VueDropzone,
  },
  data() {
    return {
      moment,
      pageLoading: false,
      isShowHistory: false,
      shouldSeeLoaderOnUpdating: true,
      isRequestingNow: [],
      item: null,
      useNullableDamageStatus: false,
      errors: {},
      dropOptions: {
        url: `${process.env.VUE_APP_API_LOCATION}/damages/${this.$route.params.damageUuid}/attachments`,
        method: 'post',
        maxFilesize: 30, // MB
        maxFiles: 20,
        clickable: true,
        // acceptedFiles: '.png,.jpg,.jpeg,.mov',
        // chunking: true,
        // chunkSize: 500, // Bytes
        // thumbnailWidth: 150, // px
        // thumbnailHeight: 150,
        addRemoveLinks: true,
        headers: {
          'Cache-Control': null,
          'X-Requested-With': null,
          Authorization: `Bearer ${localStorage.getItem('id_token')}`,
          Accept: 'application/json',
        },
        dictDefaultMessage: i18n.t('uploads.dictDefaultMessage'),
        dictFallbackMessage: i18n.t('uploads.dictFallbackMessage'),
        dictFallbackText: i18n.t('uploads.dictFallbackText'),
        dictFileTooBig: i18n.t('uploads.dictFileTooBig'),
        dictInvalidFileType: i18n.t('uploads.dictInvalidFileType'),
        dictResponseError: i18n.t('uploads.dictResponseError'),
        dictCancelUpload: i18n.t('uploads.dictCancelUpload'),
        dictCancelUploadConfirmation: i18n.t('uploads.dictCancelUploadConfirmation'),
        dictRemoveFile: i18n.t('uploads.dictRemoveFile'),
        dictMaxFilesExceeded: i18n.t('uploads.dictMaxFilesExceeded'),
      },
    };
  },
  created() {
    this.pageLoading = true;
    this.fetchData();
  },
  watch: {
    '$route.params.damageUuid': {
      handler() {
        this.fetchData();
      },
    },
  },
  methods: {
    fetchData() {
      new DamageProxy().find(this.$route.params.damageUuid)
        .then((response) => {
          this.item = response.data.data.damage;
          this.$route.meta.title = 'Ущерб';
        })
        .catch((error) => {
          console.error(error);
          return this.$router.push({
            name: 404,
          });
        })
        .finally(() => {
          this.pageLoading = false;
          this.$store.dispatch('page/finishUpdateCurrentPageContent');
        });
    },
    getUpdateSimpleRequestClient() {
      return new DamageProxy();
    },
    updateRequest(property, val) {
      if (!this.pageLoading) {
        this.isRequestingNow.push(property);
        (this.updateSimpleRequest(this.item, property))(val)
          .catch((response) => {
            this.errors = prepareValidationMessages(response.data.data);
          })
          .finally(() => {
            const index = this.isRequestingNow.indexOf(property);
            if (index !== -1) this.isRequestingNow.splice(index, 1);
          });
      }
    },
    afterComplete(file) {
      this.$refs.dropzone.removeFile(file);
    },
    onFileError(file, response) {
      const errors = prepareValidationMessages(response.data);
      if (errors.file) {
        this.$store.dispatch('page/displaySnackbar', {
          text: errors.file,
          color: 'red darken-3',
          timeout: 6000,
        });
      }
    },
    onFileUploaded() {
      this.fetchData();
    },
    isImage(url) {
      return (url.match(/\.(jpeg|jpg|gif|png)$/) != null);
    },
  },
};
</script>

<style scoped lang="scss">
  .preview-attachment {
    background-color: #66a0f7;
    width: 100%;
    padding-top: 100%; /* 1:1 Aspect Ratio */
    position: relative; /* If you want text inside of it */
    margin-bottom: 20px;

    &__content {
      display: block;
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      text-decoration: none;

      img {
        display: block;
        width: 100%;
        height: 100%;
        object-fit: cover;
      }

      .text {
        display: flex;
        width: 100%;
        height: 100%;
        color: white;
        justify-content: center;
        align-items: center;
        font-weight: bold;
        font-size: 1em;
        text-decoration: none;
      }
    }
  }
</style>
